import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import ApiOptionsConfig from './api-options.config';
import { ApiBaseService } from './api-base.service';

const BASE_URL = '/file-manager/audit';

@Injectable({
  providedIn: 'root'
})
export class FileManagerAuditService extends ApiBaseService {

  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }
}
